import React, { useEffect, useState } from "react";
import PropMaintForm from "../../forms/PropMaint/PropMaintForm";
import PropTypes from "prop-types";
import { getPropMaint } from "../../../api/propMaintApi";
import { toast } from "react-toastify";
import Axios from "axios";
import { getSignedAttachmentUrl } from "../../../api/attachApi";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const PropMaintPage = ({ history }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [propMaintDisplay, setPropMaintDisplay] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(() => {
    setIsLoading(true);
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();
    getPropMaint(source, currentYear)
      .then((result) => {
        // reset pagination
        resetPagination();

        setPropMaintDisplay(result);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
    return () => {
      source.cancel();
    };
  }, [currentYear, t]);

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewPropMaint() {
    history("/home/propmaint/proptrans");
  }

  function viewPropMaint(PropMaintKey) {
    history("/home/propmaint/proptrans/" + PropMaintKey);
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <PropMaintForm
      isLoading={isLoading}
      data={propMaintDisplay}
      onAdd={onAddNewPropMaint}
      onView={viewPropMaint}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
};

PropMaintPage.propTypes = {
  history: PropTypes.func.isRequired,
};

export default PropMaintPage;
